export const FREQ_MAP = {
  once: 'ADMIN_LABEL_FREQUENCY_ONE_TIME',
  month: 'ADMIN_LABEL_FREQUENCY_MONTHLY',
  year: 'ADMIN_LABEL_FREQUENCY_ANNUALLY',
};

export const DATE_FORMAT = 'YYYY-MM-DD';
